import React from 'react';
import { RichText } from 'prismic-reactjs';
import { useStaticQuery } from 'gatsby';
import { DisplaySmall } from './display-small.styled';
var DisplaySmallText = function DisplaySmallText(_ref) {
    var _prismicStylesConfig$;
    var richText = _ref.richText, color = _ref.color, customStyles = _ref.customStyles;
    var _useStaticQuery = useStaticQuery("1465761870"), prismicStylesConfig = _useStaticQuery.prismicStylesConfig;
    return /*#__PURE__*/ React.createElement(DisplaySmall, {
        color: color,
        customStyles: customStyles,
        configStyles: (_prismicStylesConfig$ = prismicStylesConfig.data.display_small_text_styles) === null || _prismicStylesConfig$ === void 0 ? void 0 : _prismicStylesConfig$.text
    }, /*#__PURE__*/ React.createElement(RichText, {
        render: richText
    }));
};
export default DisplaySmallText;
